module.exports = __webpack_public_path__ + "static/assets/0c7b4326a20e0f243dceaf6e44692eb7.svg";